<template>
  <div>
    <div v-for="[id,value] in Object.entries(model)">
      <component
          :is="model_type(id)"
          :bp="bp"
          :name="id"
          :data="value"
          :readonly="readonly"
          @update="update"
          :lang="lang"
          :is_mobile="is_mobile"
          :roles="roles"
        />
    </div>
  </div>
</template>
    
<script>
  import Model from '@/components/bpcreator/views/Model';
  import GenericView from '@/components/bpcreator/views/GenericView';
  import Transitions from '@/components/bpcreator/views/Transitions';
  import Inlines from '@/components/bpcreator/views/Inlines';
  import States from '@/components/bpcreator/views/States';
  import Roles from '@/components/bpcreator/views/Roles';
  import Columns from '@/components/bpcreator/views/Columns';
  import Filters from '@/components/bpcreator/views/Filters';
  export default {
    components: {
      GenericView,
      Model,
      Transitions,
      Inlines,
      States,
      Roles,
      Columns,
      Filters,
    },
        
    name: 'BPView',
        
    props: {
      bp: {default: () => ({})},
      model: {default: () => ({})},
      readonly: Boolean,
      is_mobile: Boolean,
      lang: String,
      roles: {default: ()=>({})},
    },
        
    data: () => ({
      models : {
        'model': 'Model',
        'transitions': 'Transitions',
        'inline_boxes': 'Inlines',
        'states': 'States',
        'roles': 'Roles',
        'columns': 'Columns',
        'filters': 'Filters',
      },
    }),
        
    computed: {
    },
        
    mounted() {
    },
        
    methods: {
      model_type(model) {
        return this.models[model] || 'GenericView';
      },
      update(value) {
        this.$emit('update',value);
      }
    },
    
    watch: {
    },
  }
</script>